import UnderConstruction from '../components/UnderConstruction';

function SalesTeam(props){
    return(
        <UnderConstruction/>
    )
}

export default SalesTeam;